var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.label)?_c('label',{staticClass:""},[_vm._v(_vm._s(_vm.input.display_name))]):_vm._e(),_c(_vm.type,{tag:"component",attrs:{"form":_vm.form,"label":_vm.label,"value":_vm.value,"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }